module.exports = __webpack_public_path__ + "img/axelerate-logo-white.360fc44d.svg";